import { render } from "./NotesPopup.vue?vue&type=template&id=701b2a04&scoped=true"
import script from "./NotesPopup.vue?vue&type=script&lang=js"
export * from "./NotesPopup.vue?vue&type=script&lang=js"

import "./NotesPopup.vue?vue&type=style&index=0&id=701b2a04&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701b2a04"]])

export default __exports__